/**
 * Mutation，更改state中数据状态的唯一方法。
 * 每个 mutation 都有一个字符串的 事件类型 (type) 和 一个 回调函数 (handler)。
 * 回调函数就是我们实际进行状态更改的地方，并且它会接受 state 作为第一个参数。
 * 
 * 注意： mutation必须是同步函数。
 */

import * as types from './mutation-types'


const mutations = {
  [types.SET_HEADER_INFO](store, info = {}) {
    store.headerTitle = info
  }
}


export default mutations